<template>
  <header id="header">
    <div class="container">
      <nav class="navbar navbar-expand-lg">
        <router-link tag="a" to="/" class="navbar-brand" href="/">
          <img src="/img/logo.svg">
        </router-link>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarKeyperson"
          aria-controls="navbarKeyperson"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="fa fa-bars"></span>
        </button>
        <div class="collapse navbar-collapse justify-content-end" id="navbarKeyperson">
          <ul class="navbar-nav">
            <li class="nav-item active">
              <router-link to="/" tag="a" class="nav-link">ballina</router-link>
            </li>
            <li class="nav-item">
              <router-link
                v-if="$route.name!=='selected'"
                :to="redirectToSelected()"
                tag="a"
                class="nav-link"
                @click.native="$store.state.selected.selectedPackage=0"
              >pakot</router-link>
              <router-link v-else to tag="a" class="nav-link">pakot</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/about" tag="a" class="nav-link">rreth nesh</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/agent" tag="a" class="nav-link">behu agjent</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/partner" tag="a" class="nav-link">behu partner</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/contact" tag="a" class="nav-link">kontakt</router-link>
            </li>
            <li class="nav-dropdown">
              <a v-if="!loggedIn()" href="/login" class="nav-link">kycu</a>
              <div v-if="loggedIn()">
                <a
                  class="btn nav-item dropdown-toggle"
                  href="#"
                  role="button"
                  id="dropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >{{ this.user().first_name ? `${this.user().first_name} ${this.user().last_name}` : this.user().full_name }}</a>
                <div class="dropdown-menu">
                  <router-link to="/account" tag="a" class="dropdown-item">llogaria</router-link>
                  <a class="dropdown-item" href="#" @click="logout">Shkyçu</a>
                  <router-link to="/admin" tag="a" class="dropdown-item" v-if="this.userOfType('superadmin','operations','finops','finances', 'driver')">admin</router-link>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </header>
</template>

<style src="@/assets/client/css/main.css">
</style>

<script>
export default {
  name: "Header",
  methods: {
    redirectToSelected() {
      return this.hasQueryParams
            ? {name: 'selected', query: {referral: this.$store.state.selected.currentReferralCode}}
            : {name: 'selected'};
    },
    loggedIn() {
      if (window.localStorage.getItem("token"))
      {
          return true;
      }
        
      return false;
    },
    logout() {
      this.$store.dispatch("login/logout", this.$router);
    }
  },
  async beforeMount() 
  {
    await this.$store.dispatch("account/getCurrentPromotion")

    if (this.loggedIn()) 
    {
      this.$store.dispatch("account/requestPersonalData", {
        route: this.$route,
        router: this.$router
      });
    }
  },
  computed: {
    hasQueryParams() {
      return this.$store.state.selected.currentReferralCode;
    },
  }
};
</script>